import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CompensationStatus, Namespace } from 'enums';

import { CompensationStatusItem } from '../../CompensationStatusItem';

export const useStatusOptions = (withFailedStatus?: boolean) => {
  const { t } = useTranslation(Namespace.CompensationStatuses);

  return useMemo(() => {
    return [
      CompensationStatus.Approved,
      CompensationStatus.Rejected,
      CompensationStatus.UpdateRequired,
      CompensationStatus.Pending,
      ...(withFailedStatus ? [CompensationStatus.Failed] : []),
    ].map((status) => ({
      value: status,
      label: <CompensationStatusItem status={status} />,
      key: t(status),
    }));
  }, [t, withFailedStatus]);
};
